export default __webpack_public_path__ + "static/media/251e16bea3b4dbc47766f4e9a5a99610.58c4dc20.jpg";